enum ApiConfig {
  API_PRIVATE_KEY = 'qMymank8Q0rNyJ0RxDXE',
}

export { ApiConfig };
